module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-unwatch-4ef4700d239a91000641c4ed7f50d625.svg";